import { observer } from 'mobx-react-lite';
import { createContext, PropsWithChildren, ReactElement, useState } from 'react';

interface IAdminContext {
  readonly search: string;
  setSearch(search: string): void;
}

export const AdminContext = createContext<IAdminContext>(undefined);

export const AdminContextProvider = observer((props: PropsWithChildren): ReactElement => {
  const [search, setSearch] = useState('');
  return (
    <AdminContext.Provider
      value={{
        search,
        setSearch,
      }}
    >
      {props.children}
    </AdminContext.Provider>
  );
});
